import React from "react";
import StatusBar from "../../preapps/StatusBar";
const PreappStatusBarParent = ({ t }) => {
    return (
        <div className="table-div-td col-status col-status-hover">
            <ul>
                <li>
                    {t[1].progression_id <= 6 ? (
                        <div className="app-circle">
                            <i
                                className="fa fa-circle"
                                aria-hidden="true"
                                style={{ color: "#819FEC" }}
                                title={
                                    t[1].progression
                                        ? t[1].progression.status
                                        : ""
                                }
                            />
                        </div>
                    ) : t[1].progression_id === 7 ? (
                        <div className="app-circle">
                            <i
                                className="fa fa-circle"
                                aria-hidden="true"
                                style={{ color: "#F0BE74" }}
                            />
                        </div>
                    ) : t[1].progression_id === 8 ? (
                        <div className="app-circle">
                            <i
                                className="fa fa-circle"
                                aria-hidden="true"
                                style={{ color: "#819FEC" }}
                                title="Signed"
                            />
                        </div>
                    ) : t[1].progression_id === 9 ? (
                        <div className="app-circle">
                            <i
                                className="fa fa-circle"
                                aria-hidden="true"
                                style={{ color: "#7FCECE" }}
                                title="Underwritting"
                            />
                        </div>
                    ) : t[1].progression_id === 10 ? (
                        <div className="app-circle">
                            <i
                                className="fa fa-circle"
                                aria-hidden="true"
                                style={{ color: "#E7B8DF" }}
                                title="Underwritting pending"
                            />
                        </div>
                    ) : t[1].progression_id === 11 ? (
                        <div className="app-circle">
                            <i
                                className="fa fa-circle"
                                aria-hidden="true"
                                style={{ color: "#44AE42" }}
                                title="Awaiting Reserve"
                            />
                        </div>
                    ) : t[1].progression_id === 12 ? (
                        <div className="app-circle">
                            <i
                                className="fa fa-circle"
                                aria-hidden="true"
                                style={{ color: "#44AE42" }}
                                title="Approved"
                            />
                        </div>
                    ) : t[1].progression_id === 13 ? (
                        <div className="app-circle">
                            <i
                                className="fa fa-circle"
                                aria-hidden="true"
                                style={{ color: "#FFA500" }}
                                title="Declined"
                            />
                        </div>
                    ) : t[1].progression_id === 14 ? (
                        <div className="app-circle">
                            <i
                                className="fa fa-circle"
                                aria-hidden="true"
                                style={{ color: "#660000" }}
                                title="Cancelled"
                            />
                        </div>
                    ) : t[1].progression_id === 15 ? (
                        <div className="app-circle">
                            <i
                                className="fa fa-circle"
                                aria-hidden="true"
                                style={{ color: "#44AE42" }}
                                title="App pending PC approval"
                            />
                        </div>
                    ) : t[1].progression_id === 16 ? (
                        <div className="app-circle">
                            <i
                                className="fa fa-circle"
                                aria-hidden="true"
                                style={{ color: "#F0BE74" }}
                                title=">Sent for Signature"
                            />
                        </div>
                    ) : t[1].progression_id === 17 ? (
                        <div className="app-circle">
                            <i
                                className="fa fa-circle"
                                aria-hidden="true"
                                style={{ color: "#F0BE74" }}
                                title="PDF requested"
                            />
                        </div>
                    ) : t[1].progression_id === 21 ? (
                        <div className="app-circle">
                            <i
                                className="fa fa-circle"
                                aria-hidden="true"
                                style={{ color: "#FF0000" }}
                                title="Terminated"
                            />
                        </div>
                    ) : t[1].progression_id === 22 ? (
                        <div className="app-circle">
                            <i
                                className="fa fa-circle"
                                aria-hidden="true"
                                style={{ color: "#0000FF" }}
                                title="Support"
                            />
                        </div>
                    ) : (
                        <div className="app-circle">
                            <i
                                className="fa fa-circle"
                                aria-hidden="true"
                                style={{ color: "#44AE42" }}
                                title="Awaiting wet signature"
                            />
                        </div>
                    )}
                </li>
                {t[1].child.map((child, index) => (
                    <li>
                        {child.progression_id <= 6 ? (
                            <div className="app-circle">
                                <i
                                    className="fa fa-circle"
                                    aria-hidden="true"
                                    style={{ color: "#819FEC" }}
                                    title={
                                        child.progression
                                            ? child.progression.status
                                            : "Awaiting Preapp"
                                    }
                                />
                            </div>
                        ) : child.progression_id === 7 ? (
                            <div className="app-circle">
                                <i
                                    className="fa fa-circle"
                                    aria-hidden="true"
                                    style={{ color: "#F0BE74" }}
                                    title="Sent for Signature"
                                />
                            </div>
                        ) : child.progression_id === 8 ? (
                            <div className="app-circle">
                                <i
                                    className="fa fa-circle"
                                    aria-hidden="true"
                                    style={{ color: "#819FEC" }}
                                    title="Signed"
                                />
                            </div>
                        ) : child.progression_id === 9 ? (
                            <div className="app-circle">
                                <i
                                    className="fa fa-circle"
                                    aria-hidden="true"
                                    style={{ color: "#7FCECE" }}
                                    title="Underwritting"
                                />
                            </div>
                        ) : child.progression_id === 10 ? (
                            <div className="app-circle">
                                <i
                                    className="fa fa-circle"
                                    aria-hidden="true"
                                    style={{ color: "#E7B8DF" }}
                                    title="Underwritting pending"
                                />
                            </div>
                        ) : child.progression_id === 11 ? (
                            <div className="app-circle">
                                <i
                                    className="fa fa-circle"
                                    aria-hidden="true"
                                    style={{ color: "#44AE42" }}
                                    title="Awaiting Reserve"
                                />
                            </div>
                        ) : child.progression_id === 12 ? (
                            <div className="app-circle">
                                <i
                                    className="fa fa-circle"
                                    aria-hidden="true"
                                    style={{ color: "#44AE42" }}
                                    title="Approved"
                                />
                            </div>
                        ) : child.progression_id === 13 ? (
                            <div className="app-circle">
                                <i
                                    className="fa fa-circle"
                                    aria-hidden="true"
                                    style={{ color: "#FFA500" }}
                                    title="Declined"
                                />
                            </div>
                        ) : child.progression_id === 14 ? (
                            <div className="app-circle">
                                <i
                                    className="fa fa-circle"
                                    aria-hidden="true"
                                    style={{ color: "#660000" }}
                                    title="Cancelled"
                                />
                            </div>
                        ) : child.progression_id === 15 ? (
                            <div className="app-circle">
                                <i
                                    className="fa fa-circle"
                                    aria-hidden="true"
                                    style={{ color: "#44AE42" }}
                                    title="App pending PC approval"
                                />
                            </div>
                        ) : child.progression_id === 16 ? (
                            <div className="app-circle">
                                <i
                                    className="fa fa-circle"
                                    aria-hidden="true"
                                    style={{ color: "#F0BE74" }}
                                    title="Sent for Signature"
                                />
                            </div>
                        ) : child.progression_id === 17 ? (
                            <div className="app-circle">
                                <i
                                    className="fa fa-circle"
                                    aria-hidden="true"
                                    style={{ color: "#F0BE74" }}
                                    title="PDF requested"
                                />
                            </div>
                        ) : t[1].progression_id === 21 ? (
                            <div className="app-circle">
                                <i
                                    className="fa fa-circle"
                                    aria-hidden="true"
                                    style={{ color: "#FF0000" }}
                                    title="Terminated"
                                />
                            </div>
                        ) : t[1].progression_id === 22 ? (
                            <div className="app-circle">
                                <i
                                    className="fa fa-circle"
                                    aria-hidden="true"
                                    style={{ color: "#0000FF" }}
                                    title="Support"
                                />
                            </div>
                        ) : (
                            <div className="app-circle">
                                <i
                                    className="fa fa-circle"
                                    aria-hidden="true"
                                    style={{ color: "#44AE42" }}
                                    title="Awaiting wet signature"
                                />
                            </div>
                        )}
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default PreappStatusBarParent;
